import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
import { Button } from "../../button";

export const ModalFooterButton = styled(Button)`
    flex: 1 0 auto;
    margin-left: ${sizes.small}px;
`;
